import { Controller } from 'stimulus';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class TrendingSearchesController extends Controller {
  trackTrendingSearch = (event) => {
    const searchTerm = event.currentTarget.getAttribute('data-search-term');

    triggerCustomEvent(events.search.trending_search_click, { searchTerm });
  }
}
